import styled from 'styled-components'

import Media from 'builder/styles/media'
import Colors from 'builder/styles/colors'
import { Sizes } from 'builder/styles/sizes'
import { FontWeights, Typography } from 'builder/styles/typography'
import { VaulDrawer } from 'builder/components/DrawerModal/DrawerModal'

import { NavListItem } from '../styles'

export const ModalContainer = styled.div`
  overflow: hidden;
  width: 545px;
  height: 670px;
  border-radius: 16px;
  background: ${Colors.White};
  box-shadow: 0px 6px 8px -2px rgba(15, 20, 30, 0.08), 0px 16px 64px -8px rgba(15, 20, 30, 0.32);
  position: relative;

  ${Media.Phone`
    width: 100%;
    height: calc(100vh - 72px);
  `}
`

export const ModalContent = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: ${Sizes.L};
  padding: 32px;

  ${Media.Phone`
    padding: 20px;
  `}
`

export const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const ModalTitle = styled.h1`
  ${Typography.M}
  ${FontWeights.Medium}

  color: ${Colors.Neutral90};
`

export const ModalCloseButton = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: ${Colors.Neutral10};
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  position: absolute;
  right: 32px;
  top: 32px;
`

export const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Sizes.L};
`

export const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Sizes.M};
`

export const SectionContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Sizes.S};
`

export const SectionTitle = styled.h2`
  ${Typography.Caps}
  ${FontWeights.DemiBold}

  color: ${Colors.Neutral50};
`

export const ListItem = styled(NavListItem).attrs({
  isActive: false,
})`
  padding: 0;
  height: unset;
  cursor: default;
`

export const MobileHandle = styled(VaulDrawer.Handle)`
  margin: 8px auto 4px;
  background: ${Colors.Neutral30};
`
